export default {
  notifications: [],
  storedNotifications: JSON.parse(sessionStorage.getItem('site_notifications')) || [],
  socketConnection: null
};
